<template>
  <div class="entry" style="margin: 8px 0;">
    <div class="container">
      <div class="columns is-centered is-mobile">
        <div class="column is-10 is-three-quarters-tablet is-half-desktop">
          <div style='display: flex; justify-content: center; margin: 0 0 8px 0;'>
            <div class="tags has-addons">
              <span class="tag is-info is-medium">現在の参加申し込み番組数</span>
              <span class="tag is-link is-medium">
                <channelcount></channelcount>
              </span>
            </div>
          </div>

          <div class="box">
            <div class="tags has-addons has-text-left">
              <span class="tag is-danger">新規登録</span>
              <span class="tag is-warning">初めての方は、こちらから入力＋[保存]をお願いいたします</span>
            </div>
            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label has-text-left">
                    ポッドキャストURL（WebサイトURL）
                    <span class="is-size-7 has-text-danger">※必須</span>
                  </label>
                  <div class="control has-icons-left">
                    <input
                      class="input is-danger"
                      type="text"
                      placeholder="https://example.jp/podcast"
                      v-model="entryUrl"
                    >
                    <span class="icon is-small is-left">
                      <i class="fas fa-globe"></i>
                    </span>
                  </div>
                  <div class="is-size-7 is-light is-marginless has-text-left">
                    ※見に来て欲しいURL。RSS Feed URLでは
                    <strong>ありません。</strong>
                  </div>
                </div>

                <div class="notification is-warning is-paddingless">▼以降の項目は[保存]クリック後も修正可能です▼</div>

                <div class="field">
                  <label class="label has-text-left">ポッドキャスト番組名</label>
                  <div class="control has-icons-left">
                    <input
                      class="input is-primary"
                      type="text"
                      placeholder="番組名称"
                      v-model="entryTitle"
                    >
                    <span class="icon is-small is-left">
                      <i class="fas fa-microphone-alt"></i>
                    </span>
                  </div>
                </div>

                <div class="field">
                  <label class="label has-text-left">番組紹介文</label>
                  <div class="control has-icons-left">
                    <textarea class="textarea is-primary" v-model="entryDesc" rows="2"></textarea>
                  </div>
                </div>

                <div class="field">
                  <label class="label has-text-left">アイコン（アートワーク）画像URL</label>
                  <div class="control has-icons-left">
                    <input
                      class="input is-primary"
                      type="text"
                      placeholder="https://example.jp/podcast/artwork.jpg"
                      v-model="entryImg"
                    >
                    <span class="icon is-small is-left">
                      <i class="fas fa-image"></i>
                    </span>
                  </div>
                </div>

                <div class="field">
                  <label class="label has-text-left">配信者TwitterアカウントURL</label>
                  <div class="control has-icons-left">
                    <input
                      class="input is-primary"
                      type="text"
                      placeholder="https://twitter.com/username"
                      v-model="entryPodcasterTwitterUrl"
                    >
                    <span class="icon is-small is-left">
                      <i class="fab fa-twitter"></i>
                    </span>
                  </div>
                </div>

                <div class="field">
                  <label class="label has-text-left">番組公式TwitterアカウントURL(あれば)</label>
                  <div class="control has-icons-left">
                    <input
                      class="input is-primary"
                      type="text"
                      placeholder="https://twitter.com/username"
                      v-model="entryChannelTwitterUrl"
                    >
                    <span class="icon is-small is-left">
                      <i class="fab fa-twitter"></i>
                    </span>
                  </div>
                </div>

                <div class="field">
                  <label class="label has-text-left is-marginless">お祭り用エピソードURL</label>
                  <p
                    class="has-text-left is-size-7 has-text-gray"
                  >お祭り用にエピソードをご用意いただける方はこちらにURLをご記入ください。（記載がない場合は［ポッドキャストURL］が掲載されます。）</p>
                  <div class="control has-icons-left">
                    <input
                      class="input is-primary"
                      type="text"
                      placeholder="https://example.com/podcast/215"
                      v-model="entrySpecialEpisodeUrl"
                    >
                    <span class="icon is-small is-left">
                      <i class="fas fa-globe"></i>
                    </span>
                  </div>
                </div>

                <div class="field">
                  <label class="label has-text-left is-marginless">お祭りエピソード用紹介文</label>
                  <p
                    class="has-text-left is-size-7 has-text-gray"
                  >お祭り用にエピソードをご用意いただける方はこちらに内容の紹介文をご記入ください。（記載がない場合は［番組紹介文］が掲載されます。）</p>
                  <div class="control has-icons-left">
                    <textarea
                      class="textarea is-primary"
                      v-model="entrySpecialEpisodeDesc"
                      rows="2"
                    ></textarea>
                  </div>
                </div>

                <div class="column is-narrow">
                  <button
                    class="button is-medium is-primary"
                    type="submit"
                    v-on:click="updateEntry()"
                    @keydown.esc="setModal(false)"
                  >保存</button>
                </div>
              </div>
            </div>
          </div>

          <div class="box">
            <div class="tags has-addons has-text-left">
              <span class="tag is-link">修正</span>
              <span class="tag is-info">登録済みの方はこちらから検索→修正をお願いします</span>
            </div>
            <div class="field">
              <div class="columns is-vcentered">
                <div class="column is-narrow">
                  <label class="label has-text-left" style="line-height: 1em;">
                    検索する文字列
                    <br>
                    <span
                      class="is-size-7 is-light has-text-weight-light is-marginless has-text-left"
                    >検索対象：番組名、各種URLなど全項目</span>
                  </label>
                </div>
                <div class="column">
                  <div class="control has-icons-left">
                    <input
                      class="input is-primary"
                      type="text"
                      placeholder="最初の1件が編集対象となります"
                      v-model="searchKeyword"
                    >
                    <span class="icon is-small is-left">
                      <i class="fas fa-globe"></i>
                    </span>
                  </div>
                </div>
                <div class="column is-narrow">
                  <button class="button" type="button" v-on:click="searchEntry()">検索</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" :class="{'is-active' : isModalActive}">
      <div class="modal-background" v-on:click="setModal(false)"></div>
      <div class="modal-content">
        <div class="box">
          <p>お申込みありがとうございます！</p>
          <p>登録が完了しました。お祭りエピソードなど、後から修正が可能です。</p>
          <br>
          <p>【修正の手順】</p>
          <p>1)本画面の下部にてキーワード検索を行います</p>
          <p>2)該当した1件目が入力欄に表示されます</p>
          <p>3)修正し[保存]ボタンをクリックします</p>
          <br>
          <p>
            質問・ご意見などありましたら、
            <a href="https://twitter.com/goodengineer7">Twitter @goodengineer7</a>までメンション／DMにてお声がけください。
          </p>
          <p>
            一緒にお祭りを盛り上げていきましょー
            <span class="icon has-text-danger">
              <i class="fas fa-heart"></i>
            </span>
          </p>
          <br>
          <button class="button" v-on:click="setModal(false)">OK</button>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" v-on:click="setModal(false)"></button>
    </div>
  </div>
</template>

<script>
import firebase from "@/components/FirebaseInit";
import channelcount from "@/components/ChannelCount";
import { toastedOptions } from "@/components/CommonSettings";

export default {
  name: "entry",
  components: { channelcount },
  data() {
    return {
      database: null,
      entriesRef: null,
      searchKeyword: "",
      entryUrl: "",
      entryTitle: "",
      entryDesc: "",
      entryImg: "",
      entryPodcasterTwitterUrl: "",
      entryChannelTwitterUrl: "",
      entrySpecialEpisodeUrl: "",
      entrySpecialEpisodeDesc: "",
      entries: [],
      isModalActive: false
    };
  },
  created: function() {
    this.entriesRef = firebase.collection("entries");
    this.entriesRef.onSnapshot(querySnapshot => {
      this.entries = this.getAllEntries(querySnapshot);
    });
  },
  computed: {},
  methods: {
    getAllEntries: function() {
      let newEntries = [];
      this.entriesRef
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            newEntries.push(doc.data());
          });
          this.entries = newEntries;
        })
        .catch(error => {
          this.showDbError(error);
        });
    },
    searchEntry: function() {
      if (this.searchKeyword === "") {
        this.$toasted.show(
          "検索キーワードを入力してください",
          toastedOptions.Info
        );
        return;
      }
      this.getAllEntries();
      // search
      for (let key in this.entries) {
        let targetStrings =
          decodeURIComponent(this.entries[key]["entryUrl"]) +
          this.entries[key]["entryTitle"] +
          this.entries[key]["entry"] +
          this.entries[key]["entryDesc"] +
          this.entries[key]["entryImg"] +
          this.entries[key]["entryPodcasterTwitterUrl"] +
          this.entries[key]["entryChannelTwitterUrl"] +
          this.entries[key]["entrySpecialEpisodeUrl"] +
          this.entries[key]["entrySpecialEpisodeDesc"];
        if (targetStrings.indexOf(this.searchKeyword) != -1) {
          this.loadEntry(this.entries[key]);
          this.$toasted.show("データを取得しました", toastedOptions.Success);
          return;
        }
      }
      this.$toasted.show(
        "該当するデータが見つかりませんでした",
        toastedOptions.Info
      );
    },
    loadEntry: function(entry) {
      this.entryUrl = decodeURIComponent(entry.entryUrl);
      this.entryTitle = entry.entryTitle;
      this.entryDesc = entry.entryDesc;
      this.entryImg = entry.entryImg;
      this.entryPodcasterTwitterUrl = entry.entryPodcasterTwitterUrl;
      this.entryChannelTwitterUrl = entry.entryChannelTwitterUrl;
      this.entrySpecialEpisodeUrl = entry.entrySpecialEpisodeUrl;
      this.entrySpecialEpisodeDesc = entry.entrySpecialEpisodeDesc;
    },
    updateEntry: function() {
      let encUrl = encodeURIComponent(this.entryUrl);
      if (encUrl == "" || this.entryTitle == "") {
        this.$toasted.show(
          "「URL」「番組名」を入力してください",
          toastedOptions.Error
        );
        return;
      }
      // New entry ? or Update ?
      let docRef = this.entriesRef.doc(encUrl);
      let isExist = false;
      docRef
        .get()
        .then(doc => {
          isExist = doc.exists;

          let current_date = new Date();
          let objEntry = {
            entryUrl: encUrl,
            entryTitle: this.entryTitle,
            entryDesc: this.entryDesc,
            entryImg: this.entryImg,
            entryPodcasterTwitterUrl: this.entryPodcasterTwitterUrl,
            entryChannelTwitterUrl: this.entryChannelTwitterUrl,
            entrySpecialEpisodeUrl: this.entrySpecialEpisodeUrl,
            entrySpecialEpisodeDesc: this.entrySpecialEpisodeDesc
          };

          if (isExist) {
            objEntry.entryUpdatedAt = current_date;
            docRef
              .update(objEntry)
              .then(() => {
                this.$toasted.show(
                  "データを保存しました",
                  toastedOptions.Success
                );
              })
              .catch(error => {
                this.showDbError(error);
              });
          } else {
            objEntry.entryCreatedAt = current_date;
            docRef
              .set(objEntry)
              .then(() => {
                this.$toasted.show(
                  "データを保存しました",
                  toastedOptions.Success
                );
                this.setModal(true);
              })
              .catch(error => {
                this.showDbError(error);
              });
          }
        })
        .catch(error => {
          this.showDbError(error);
        });
    },
    showDbError: function(error) {
      this.$toasted.show(
        "データ取得時にエラーが発生しました:" + error.message,
        toastedOptions.Error
      );
    },
    setModal: function(isActive) {
      this.isModalActive = isActive;
    }
  }
};
</script>
